/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { getPropertiesAggregatedStats } from "../../../actions";
import AppGrids from "../../../components/AppGrids";
import Popup from "reactjs-popup";
import "./styles.scss";
import PeriodSelector from "../../../components/PeriodSelector/PeriodSelector";
import moment from "moment";
import Header from "../../../components/Header/Header";
import { useLocation } from "react-router-dom";
import { history } from "../../../config/stores";

const cardTypes = [
  {
    header: "MUTUAL PROPERTY MANAGEMENT",
    firstLine: "NUMBER TOTAL MUTUAL PROPERTY MANAGEMENT",
    secondLine: "NUMBER TOTAL USERS IN MUTUAL PROPERTY MANAGEMENT",
    firstField: "mutualManagementCount",
    secondField: "mutualManagementUsers",
    tab: "mutual-management",
  },
  {
    header: "LANDLORD - TENANT RELATIONSHIP",
    firstLine: "TOTAL NUMBER OF RELATIONSHIPS",
    secondLine: "TOTAL USERS IN RELATIONSHIPS",
    firstField: "relationshipsCount",
    secondField: "relationshipsUsers",
    tab: "landlord-tenant",
  },
  {
    header: "RENT PAYMENTS",
    firstLine: "TOTAL NUMBER OF RENT PAYMENTS",
    secondLine: "TOTAL NUMBER OF USERS PAYING RENT",
    firstField: "rentPaymentsCount",
    secondField: "rentPaymentsUsers",
    tab: "rent-payments",
  },
  {
    header: "ROLE SWITCHES",
    firstLine: "TOTAL NUMBER OF SWITCHES",
    secondLine: "TOTAL NUMBER OF USERS SWITCHING",
    firstField: "roleSwitchesCount",
    secondField: "roleSwitchesUsers",
    tab: "role-switches",
  },
  {
    header: "UTILITY BILLS",
    firstLine: "TOTAL NUMBER OF BILLS",
    secondLine: "TOTAL NUMBER OF USERS PAYING BILLS",
    firstField: "utilityBillsCount",
    secondField: "utilityBillsUsers",
    tab: "utility-bills",
  },
  {
    header: "FILES",
    firstLine: "TOTAL NUMBER OF FILES",
    secondLine: "TOTAL STORAGE SPACE",
    firstField: "filesCount",
    secondField: "storageSpace",
    tab: "files",
  },
  {
    header: "FOLDERS",
    firstLine: "TOTAL NUMBER OF FOLDERS",
    secondLine: "TOTAL NUMBER OF USERS CREATING FOLDERS",
    firstField: "foldersCount",
    secondField: "foldersUsers",
    tab: "folders",
  },
  {
    header: "CALENDAR",
    firstLine: "TOTAL NUMBER OF CREATED EVENTS",
    secondLine: "TOTAL NUMBER OF USERS CREATING EVENTS",
    firstField: "eventsCount",
    secondField: "eventsUsers",
    tab: "calendar-events",
  },
  {
    header: "CHAT AND TO DOS",
    firstLine: "TOTAL NUMBER OF CREATED CHAT ROOMS",
    secondLine: "TOTAL NUMBER OF ACTIVE USERS IN CHAT",
    firstField: "chatRoomsCount",
    secondField: "chatActiveUsers",
    tab: "chat-todos",
  },
  {
    header: "ASSISTANT",
    firstLine: "TOTAL NUMBERS OF REQUESTS",
    secondLine: "TOTAL USERS CREATING REQUESTS",
    firstField: "assistantRequestsCount",
    secondField: "assistantUsers",
    tab: "assistant",
  },
];

const AppProperties = ({ propertiesStats, getPropertiesAggregatedStats }) => {
  const location = useLocation();
  const scrollContainerRef = useRef(null);
  
  // Initialize tab from URL params or default
  const getInitialTab = () => {
    const urlParams = new URLSearchParams(location.search);
    const tabFromUrl = urlParams.get('tab');
    return tabFromUrl && cardTypes.some(card => card.tab === tabFromUrl) ? tabFromUrl : "mutual-management";
  };
  
  const [selTab, setSelTab] = useState(getInitialTab());
  const [selPeriod, setSelPeriod] = useState({
    type: "all",
    startDate: null,
    endDate: null,
    label: "All time"
  });

  // Function to save scroll position
  const saveScrollPosition = () => {
    if (scrollContainerRef.current) {
      const scrollLeft = scrollContainerRef.current.scrollLeft;
      localStorage.setItem('app-properties-scroll', scrollLeft.toString());
    }
  };

  // Function to restore scroll position
  const restoreScrollPosition = () => {
    if (scrollContainerRef.current) {
      const savedScroll = localStorage.getItem('app-properties-scroll');
      if (savedScroll) {
        scrollContainerRef.current.scrollLeft = parseInt(savedScroll, 10);
      }
    }
  };

  // Function to change tab and update URL
  const changeTab = (newTab) => {
    setSelTab(newTab);
    saveScrollPosition();
    
    // Update URL with new tab
    const newUrl = `${location.pathname}?tab=${newTab}`;
    history.push(newUrl);
  };

  // Function to load properties stats based on period
  const loadPropertiesStats = (period = selPeriod) => {
    let statsPayload = {};
    
    if (period.type === "all" || (!period.startDate && !period.endDate)) {
      statsPayload = { startDate: "", endDate: "" };
    } else if (period.startDate && period.endDate) {
      statsPayload = {
        startDate: moment(period.startDate).format('YYYY-MM-DD HH:mm:ss'),
        endDate: moment(period.endDate).format('YYYY-MM-DD HH:mm:ss'),
      };
    }

    // Load properties aggregated stats
    getPropertiesAggregatedStats(statsPayload);
  };

  useEffect(() => {
    loadPropertiesStats();
    // Restore scroll position after component mounts
    setTimeout(restoreScrollPosition, 100);
  }, []);

  // Update stats when period changes
  useEffect(() => {
    loadPropertiesStats(selPeriod);
  }, [selPeriod]);

  // Prepare display stats with properties data - FIXED: Corrected API field mappings
  const displayStats = {
    // Card 1 - Mutual Management ✅ FIXED: Now mapped to API
    mutualManagementCount: propertiesStats?.sharedManagement?.properties || 0,
    mutualManagementUsers: propertiesStats?.sharedManagement?.users || 0,
    
    // Card 2 - Landlord-Tenant ✅ FIXED: Now mapped to API
    relationshipsCount: propertiesStats?.landlordTenant?.properties || 0,
    relationshipsUsers: propertiesStats?.landlordTenant?.users || 0,
    
    // Card 3 - Rent Payments ✅ FIXED: Corrected field names
    rentPaymentsCount: propertiesStats?.rentPayments?.rentPayments || 0,
    rentPaymentsUsers: propertiesStats?.rentPayments?.users || 0,
    
    // Card 4 - Role Switches ❌ MISSING: API doesn't provide this data yet
    roleSwitchesCount: "---",
    roleSwitchesUsers: "---",
    
    // Card 5 - Utility Bills ✅ FIXED: Corrected field names
    utilityBillsCount: propertiesStats?.utilityBills?.payments || 0,
    utilityBillsUsers: propertiesStats?.utilityBills?.users || 0,
    
    // Card 6 - Files ✅ FIXED: Corrected field names
    filesCount: propertiesStats?.files?.files || 0,
    storageSpace: propertiesStats?.files?.storageSpace || "0 MB",
    
    // Card 7 - Folders ✅ FIXED: Corrected field names
    foldersCount: propertiesStats?.folders?.folders || 0,
    foldersUsers: propertiesStats?.folders?.users || 0,
    
    // Card 8 - Calendar Events ✅ FIXED: Corrected field names
    eventsCount: propertiesStats?.events?.events || 0,
    eventsUsers: propertiesStats?.events?.users || 0,
    
    // Card 9 - Chat & ToDos ✅ FIXED: Corrected field names
    chatRoomsCount: propertiesStats?.chats?.chats || 0,
    chatActiveUsers: propertiesStats?.chats?.users || 0,
    
    // Card 10 - Assistant ✅ FIXED: Corrected field names and typo
    assistantRequestsCount: propertiesStats?.assistantQueries?.assistantQueries || 0,
    assistantUsers: propertiesStats?.assistantQueries?.users || 0,
  };

  return (
    <>
      <Header />
      <div className="main-container app-properties">
        <div
          ref={scrollContainerRef}
          className="app-header-container"
          style={{
            height: "auto",
            width: "100%",
            padding: "10px",
            display: "flex",
            overflowX: "scroll",
            overflowY: "hidden",
          }}
        >
          {cardTypes.map((card, i) => {
            return (
              <div
                key={i}
                className={`card-grid ${
                  card.tab === selTab && "selected"
                }`}
              >
                <div
                  className={`card-header ${
                    card.tab === selTab && "selected"
                  }`}
                  onClick={() => {
                    changeTab(card.tab);
                  }}
                >
                  <h2
                    className={`${
                      card.tab === selTab ? "font-bold" : "font-semiBold"
                    }`}
                    style={{
                      textTransform: "uppercase",
                      width: "93%",
                      marginLeft: "5px",
                      lineHeight: "1.2",
                    }}
                  >
                    {card.header}
                  </h2>
                  <p style={{ whiteSpace: "nowrap" }}>
                    {selPeriod?.label || "All Time"}
                  </p>
                  <Popup
                    className="popup-header-options-container"
                    trigger={
                      <div
                        className={`settings-icon ${
                          card.tab === selTab && "selected"
                        }`}
                      />
                    }
                    position="bottom right"
                  >
                    {(close) => (
                      <PeriodSelector
                        selectedPeriod={selPeriod.type}
                        isLastCard={i === cardTypes.length - 1}
                        onApply={(period) => {
                          setSelPeriod(period);
                          close();
                        }}
                      />
                    )}
                  </Popup>
                </div>
                <div className="card-body">
                  <div className="card-row">
                    <div className="indicator blue" />
                    <p className="row-data">
                      <b>
                        {card.firstField === "storageSpace" 
                          ? `${displayStats?.filesCount || 0} FILES / ${displayStats?.storageSpace || "0 MB"}`
                          : (card.firstField === "roleSwitchesCount" || card.firstField === "roleSwitchesUsers")
                            ? "---"
                            : (displayStats?.[card?.firstField] !== undefined ? displayStats[card?.firstField] : "---")
                        } 
                      </b>
                      <br />
                      <span className="metric-text">
                        {card.firstLine}
                      </span>
                    </p>
                  </div>
                  <div className="card-row">
                    <div className="indicator blue" />
                    <p className="row-data">
                      <b>
                        {(card.secondField === "roleSwitchesUsers" || card.secondField === "roleSwitchesCount")
                          ? "---"
                          : (displayStats?.[card?.secondField] !== undefined ? displayStats[card?.secondField] : "---")
                        } 
                      </b>
                      <br />
                      <span className="metric-text">
                        {card.secondLine}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="body-container" style={{ height: "73%" }}>
          {selTab === "mutual-management" ? (
            <AppGrids.SharedManagementInvitations period={selPeriod} />
          ) : selTab === "landlord-tenant" ? (
            <AppGrids.LandlordTenantInvitations period={selPeriod} />
          ) : selTab === "rent-payments" ? (
            <AppGrids.RentPayments period={selPeriod} />
          ) : selTab === "role-switches" ? (
            <div className="placeholder-tab">
              <h3>ROLE SWITCHES</h3>
              <p>API endpoint not available yet. Coming soon...</p>
            </div>
          ) : selTab === "utility-bills" ? (
            <AppGrids.UtilityBills period={selPeriod} />
          ) : selTab === "files" ? (
            <AppGrids.Files period={selPeriod} />
          ) : selTab === "folders" ? (
            <AppGrids.Folders period={selPeriod} />
          ) : selTab === "calendar-events" ? (
            <AppGrids.CalendarEventsProperties period={selPeriod} />
          ) : selTab === "chat-todos" ? (
            <AppGrids.ChatTodos period={selPeriod} />
          ) : selTab === "assistant" ? (
            <AppGrids.AssistantProperties period={selPeriod} />
          ) : (
            <div>Select a tab to view data</div>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  propertiesStats: state.appProperties.propertiesStats,
});

const mapDispatchToProps = (dispatch) => ({
  getPropertiesAggregatedStats: (payload) => dispatch(getPropertiesAggregatedStats(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppProperties);